import { render } from "./teacher-profile-layout.vue?vue&type=template&id=6cc9cd10&scoped=true"
import script from "./teacher-profile-layout.vue?vue&type=script&lang=js"
export * from "./teacher-profile-layout.vue?vue&type=script&lang=js"

import "./teacher-profile-layout.vue?vue&type=style&index=0&id=6cc9cd10&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc9cd10"]])

export default __exports__